import styled from 'styled-components';

// Tamanho fixo; a posição é da toolbar, que a ancora. A área de hover é maior
// que a barra: 4px de altura não dá para mirar com o mouse.
export const HitArea = styled.div`
  width: 240px;
  padding: 5px 0;
  cursor: default;
`;

export const Bar = styled.div`
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.25);
  overflow: hidden;
`;

const PHASE_COLOR = { download: '#0b84ff', tree: '#8b5cf6', properties: '#34c759' };

export const Fill = styled.div<{ $percent: number; $phase: keyof typeof PHASE_COLOR }>`
  width: ${({ $percent }) => $percent}%;
  height: 100%;
  border-radius: 2px;
  background: ${({ $phase }) => PHASE_COLOR[$phase]};
  transition: width 0.2s ease-out;
`;
